import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Row, Col, Button, Grid, Carousel } from 'antd';
import { useSelector } from 'react-redux';
import styles from './index.less';
import { mixpanel } from '../../third_party/Mixpanel';
import FrozenRatio from '../../components/FrozenRatio/FrozenRatio';
import Link from 'next/link';
import { FormattedMessage, useIntl } from 'react-intl';
import { localeSelector } from '../../selector/app';
const { useBreakpoint } = Grid;

const POSProductAdvanceCard = ({
  cover,
  covers,
  title,
  items,
  description,
  layout,
  direction = 'normal',
  borderRadius = '16px',
  flex = [1, 1],
  coverRatio = null,
  link = '',
}) => {
  const screens = useBreakpoint();
  const locale = useSelector(localeSelector);
  let direction_ = screens.xl ? direction : 'normal';
  return (
    <div className={styles.ProductAdvanceCard}>
      <div className={`production-advance-card ${screens.xl ? layout : ''}`} style={{ borderRadius }}>
        {cover && (
          <div className="top-container" style={{ order: direction_ === 'normal' ? '1' : '2', flex: flex[0] }}>
            <FrozenRatio
              ratio={coverRatio ? coverRatio : layout == 'row' && !screens.xl ? 0.460227272727273 : 360 / 640}
              className="frozen-ratio-cover"
            >
              <img className="top-image" src={cover} alt={title || 'chowbuspos'} />
            </FrozenRatio>
          </div>
        )}
        {covers && covers.length !== 0 && (
          <div className="top-container" style={{ order: direction_ === 'normal' ? '1' : '2', flex: flex[0] }}>
            <Row gutter={[0, 10]}>
              {covers.map(({ src, ratio }, index) => {
                return (
                  <Col key={index} xs={24} sm={24 / covers.length}>
                    <FrozenRatio
                      ratio={ratio ? ratio : layout == 'row' && !screens.xl ? 0.460227272727273 : 360 / 640}
                      className="frozen-ratio-cover"
                    >
                      <img className="top-image" src={src} alt={title || 'chowbuspos'} />
                    </FrozenRatio>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
        <div className="description-container" style={{ order: direction_ === 'normal' ? '2' : '1', flex: flex[1] }}>
          {title && <p className="title">{title}</p>}
          {description && <p className="subtitle">{description}</p>}
          {items && items.length !== 0 && (
            <React.Fragment>
              <ul className="keypoint-list">
                {items.map((item, index) => {
                  let { desc } = item;
                  return (
                    <li key={index} className="keypoint-item">
                      {desc}
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          )}

          {link && (
            <div className="link-more">
              {link && (
                <div className="link-more-wrapper">
                  <Link href={link}>
                    <a className="footer-link">
                      <FormattedMessage id="home.link.more" />
                    </a>
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const POSProductAdvanceThroughCard = ({
  cover,
  title,
  description,
  items,
  layout,
  direction = 'normal',
  borderRadius = '16px',
  flex = [1, 1],
}) => {
  const screens = useBreakpoint();
  const locale = useSelector(localeSelector);
  let direction_ = screens.xl ? direction : 'normal';
  return (
    <div className={`${styles.ProductAdvanceCard} ${styles.through}`}>
      <div className={`production-advance-card ${screens.xl ? layout : ''}`}>
        <div className="top-container" style={{ order: direction_ === 'normal' ? '1' : '2' }}>
          <FrozenRatio ratio={layout == 'row' && !screens.xl ? 0.460227272727273 : 1.0}>
            <img className="top-image" src={cover} alt={title || 'chowbuspos'} />
          </FrozenRatio>
        </div>
        <div className="description-container" style={{ order: direction_ === 'normal' ? '2' : '1' }}>
          {title && <p className="title">{title}</p>}
          {description && <p className="subtitle">{description}</p>}
          <ul className="keypoint-list">
            {(items || []).map((item, index) => {
              let { desc } = item;
              return (
                <li key={index} className="keypoint-item">
                  {desc}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default POSProductAdvanceCard;
